// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1cbaS","title":"Images45_title__3iHMy","images":"Images45_images__1VrJJ"};